// feeds PODCASTS
import { useState } from "react";
import Seo from "./Seo";
// fa-solid fa-pause, fa-solid fa-play

function MainContent({resource}) {

  // const audioPlayer = document.getElementById('audioPlayer');
  const topTitle = resource.content[0].title;
  const topDescription = resource.content[0].description;
  const topShowId = resource.content[0].id;
  // let curVol = getVolFunction();
  // const topDescription = 'this is a new description';
  //const [playing, setPlaying] = useState(require(`./assets/media/LNCAug292016.mp3`));
  //const [title, setTitle] = useState("Aug. 29 / 2016");
  const [title, setTitle] = useState(topTitle);
  const [description, setDescription]= useState(topDescription);
  const [playing, setPlaying] = useState(require(`./assets/media/${topShowId}.mp3`));
  //const [loaded, setLoaded] = useState();
  const [autoplay, setAutoplay] = useState(false);
  // const [onClickDisabled, setOnClickDisabled] = useState(false);
  // const [vol, setVol] = useState();

  function settingVolume(){
    const audioPlayer = document.getElementById('audioPlayer');
    audioPlayer.volume = 0.5;
  }

  function ShowPlaying() {
    // const audioTag = document.getElementById('audioPlayer');
    const playerScreen = document.querySelector('.player');
    playerScreen.classList.add('playing');
    // function getVolFunction(value){
    //   return curVol;
    // }
    // console.log(audioTag.volume);
   //  let x = audioTag.volume;
    // console.log(x); // returns the correct value
    // useEffect(()=>{
    //     console.log(`It's ${vol} around here!`);
    // }, [vol]); // dependency array
  }
  function showPaused() {
     const playerScreen = document.querySelector('.player');
    if(playerScreen.classList.contains('playing'))
     playerScreen.classList.remove('playing');
  }

  // const disableClick = (event) => {
  //   event.preventDefault();
  //   setOnClickDisabled(!onClickDisabled);
  // };
  // const handleButtonClick = (event) => {
    
  // }

  
 
  function PlayButton({id, play, newTitle, newDescription }){ 
    // const volKnob = document.getElementById('audioPlayer');
    // function volumeSetting() { 
    //     return volKnob.volume;
    //   }

    // returning playlist "play "buttons
    return (<button className="pressPlay" aria-label="Press Play" onClick={(e)=> {
      const buttonId = document.getElementById(id);
      const greyOut = document.querySelector('.loaded');
      // console.log(volKnob.volume);
       
      // const audioTag = document.getElementById('audioPlayer');
      // const volumeSetting = audioTag.volume;
      // console.log(audioTag.volume);
      // console.log(volumeSetting);
      greyOut.classList.remove('loaded');
      buttonId.classList.add('loaded');
      
      
      //e.target.parentNode.parentNode.classList.add('loaded');
      // console.log('button id:', buttonId);
      // console.log('parentnode', e.target.parentNode);
      // console.log('classlist: ', e.target.parentNode.parentNode.classList);
      setAutoplay(true);
      setPlaying(require(`./assets/media/${play}.mp3`));
      setTitle(newTitle);
      
      setDescription(newDescription)} } ><i className="fa-solid fa-play"></i></button>);
      
  }


  // function NoPlayButton(){
  //   return(
  //     <button className="pressPlay" ><i className="fa-solid fa-play"></i></button>
  //   )
  // }
 
  
  function AudioSource(){
    // let audioTag = document.getElementById("audioPlayer");

    // audioTag.volume = 0.5;
    
 
//     audioTag.onChange("volumechange", (event) => {
//     console.log("The volume changed.");
// });
    // console.log(audioVolume);

    // returns actual audioPlayer with controls
    return (
      <audio id="audioPlayer" controls onLoadStart={settingVolume} autoPlay={autoplay} onPlaying={ShowPlaying} onPause={showPaused}>
      <source src={playing} type="audio/mpeg" />
      </audio>
    )
  }
  // function AudioDisplay(){
  //   return (
  //     <div className="display">
  //         <p><b className="nowPlaying"><i>{resource.from}</i></b><cite className="citeTitle">{title}</cite></p>
  //         <p>{description}</p>
  //       </div>
  //   )
  // }
  function AudioDisplay(){
    return (
      <div className="display">
          <p><cite className="citeTitle">{title}</cite></p>
          <p>{description}</p>
        </div>
    )
  }

  // function Player(){
   
  //   return(
  //       <div className="player">
  //         <AudioDisplay />
  //         <AudioSource />
  //       </div>
  //   )
  // }

  return (
    <>
    <Seo title={resource.tabHeading} description={resource.metaDescription} keywords={resource.keywords}/>
    <div className="main stickyPlayer">
    <div className="player notPlaying">
          <AudioDisplay />
          <AudioSource />
        </div>
        <p className="alsoYT"><i>--- Available on YouTube ---</i></p>
      </div>
      <h2 className="sectionHeader">Podcasts <span className="by"></span></h2>
      <div className="main">
      <div className="playlist">
        <ol className="ulNone">
        {resource.content.map((showBlock, idn) => {
          if(idn === 0){
            // console.log('title: ', showBlock.title);
            // console.log('description: ', showBlock.description);
            // console.log('id: ', showBlock.id);
            
            return (
              <li key={idn}>
              <div className="showBlock loaded" id={idn} >
                    <PlayButton id={idn} play={showBlock.id} newDescription={showBlock.description} newTitle={showBlock.title} />
                    <p><b>{showBlock.title}</b> - {showBlock.description}</p>
                    <hr />
                </div>
                </li>
            )
          } else {
          
            return (
                <li key={idn}>
                <div className="showBlock" id={idn} >
                    <PlayButton id={idn} play={showBlock.id} newDescription={showBlock.description} newTitle={showBlock.title} />
                    <p><b>{showBlock.title}</b> - {showBlock.description}</p>
                    <hr />
                </div> 
                </li>   
                    );
          }
            })}
      </ol></div>
    </div>
    </>
);
};
export default MainContent;